module.exports = __webpack_public_path__ + "media/images/mailer/footer-00384eeee4120c5ac913bdbb5f11da8c.jpg";